import { Button } from '@/components/Elements';
import { DeleteOutline } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import { useRef, useState } from 'react';
import { InterviewInputProps } from '../types';

// 画像アップロード
export const InterViewImageUpload = (props: InterviewInputProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const captureInputRef = useRef<HTMLInputElement | null>(null);
  // 画像URL
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  // fileSelect
  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  // cameraCapture
  const handleCaptureButtonClicK = () => {
    captureInputRef.current?.click();
  };

  // cancel
  const handleCancelButtonClick = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    if (captureInputRef.current) {
      captureInputRef.current.value = '';
    }
    // 親にもnullを通知（任意）
    props.onChange({
      id: props.id,
      file: undefined,
      label: undefined
    });
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setPreviewUrl(objectUrl);
      props.onChange({
        id: props.id,
        file: file,
        label: file.name
      });
    }
  };

  const ButtonStyle = 'w-[100%] bg-white';

  return (
    <Box sx={{ width: '100%' }}>
      {/* 画像表示 */}
      {previewUrl ? (
        <img
          src={previewUrl}
          alt="アップロードされた画像"
          style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
        />
      ) : (
        <Box
          sx={{
            height: '14rem',
            width: '90%',
            background: '#D6D3D0',
            borderRadius: '10px',
            marginY: '5px',
            marginX: 'auto',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Box sx={{ marginY: 'auto', height: 'auto', width: '25%' }}>
            <InsertPhotoOutlinedIcon sx={{ width: '100%', height: 'auto' }} className="h-auto text-white" />
            <Typography className="text-[4vw] text-white font-semibold whitespace-nowrap">NO IMAGE</Typography>
          </Box>
        </Box>
      )}
      {/* ボタン類 */}
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: '15%', marginX: '2px' }}>
          <input
            accept="image/*"
            ref={fileInputRef}
            type="file"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          <Button className={ButtonStyle} onClick={handleButtonClick}>
            <FileUploadOutlinedIcon className="text-[#424242]" />
          </Button>
        </Box>
        <Box sx={{ width: '15%', marginX: '2px' }}>
          <input
            accept="image/*"
            ref={captureInputRef}
            capture="environment"
            type="file"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          <Button className={ButtonStyle} onClick={handleCaptureButtonClicK}>
            <CameraAltOutlinedIcon className="text-[#424242]" />
          </Button>
        </Box>
        <Box sx={{ width: '15%', marginX: '2px' }}>
          <Button className={ButtonStyle} onClick={handleCancelButtonClick}>
            <DeleteOutline className="text-[#424242]" />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
